import { Divider } from '@mui/material'
import React from 'react'
import { TitleContentProps } from './types'

export const TitleContent: React.FC<TitleContentProps> = ({
	title,
	content,
	content2,
	isFull = false,
	noBorder = false,
	isBig = false,
	onClickContent,
	classNamesButton = '',
	children
}) => {
	return (
		<>
			<div
				className={`flex items-center gap-2 ${
					!isFull
						? content2
							? 'w-fit max-w-[400px]'
							: 'w-fit max-w-[320px]'
						: 'w-full justify-between'
				} p-2 w-full `}
			>
				{title && (
					<p className="text-[15px] text-gray-18 font-bold font-Inter">
						{title}
					</p>
				)}
				<button
					type="button"
					onClick={onClickContent}
					className={`flex justify-center items-center border border-blue-primary min-w-[40px] rounded-full p-2 ${classNamesButton}`}
				>
					<p
						className={`${isBig ? 'text-[18px]' : 'text-[15px]'} 
            ${
							content2
								? 'max-w-[100px]'
								: 'max-w-[290px] overflow-hidden text-ellipsis whitespace-nowrap'
						} ${onClickContent ? '!cursor-pointer' : 'cursor-default'}
            text-black-1 font-normal font-Inter capitalize break-words cursor-default`}
						title={content}
					>
						{content}
					</p>

					{content2 && (
						<p
							className={`${
								isBig ? 'text-[18px]' : 'text-[15px]'
							} max-w-[250px] text-black-1 font-normal font-Inter capitalize cursor-default border-l border-blue-primary ml-2 pl-2 overflow-hidden text-ellipsis whitespace-nowrap`}
							title={content2}
						>
							{content2}
						</p>
					)}
				</button>
				{children}
			</div>
			{!noBorder && (
				<Divider orientation="vertical" variant="middle" flexItem />
			)}
		</>
	)
}
